import React from "react";
import './index.scss';

const Footer = () =>
  <div className='Footer'>
    <p>© 2021 Science Students' Collective India</p>
  </div>

export default Footer;